$(document).ready(function () {
    function showMegaMenu() {
        $('body').addClass('is-show-mega-menu');
        $('.js-mega-menu-review:not(.is-updated)').each(function () {
            if ($(this).find('a.text-m').length > 0) {
                $(this).find('a.text-m').text($(this).find('a.text-m').text().replace('Reviews', '').replace('Review', '') + ' (' + $(this).find('.yotpo-stars .sr-only').text().replace(' star rating', '') + ')')
                $(this).addClass('is-updated');
            }
        })
    }

    function hideMegaMenu() {
        $('body').removeClass('is-show-mega-menu');
        $('.navbar-item.is-mega-menu-open').removeClass('is-mega-menu-open');
    }

    if ($('.dropdown-click--false').length > 0) {
        $('.site-header .navbar-item').on('mouseover', function () {
            var menuLink = $(this).attr('data-navlink-handle');
            $('.mega-menu').removeClass('is-active');
            $('.mega-menu[data-parent-link=' + menuLink + ']').css("top", $("#shopify-section-header").height());
            $('.mega-menu[data-parent-link=' + menuLink + ']').css("height", $(window).height() - $("#shopify-section-header").height());
            $('.mega-menu[data-parent-link=' + menuLink + ']').css("overflow-y", "auto");
            $('.mega-menu[data-parent-link=' + menuLink + ']').addClass('is-active');
            showMegaMenu()
        })

        $('.mega-menu.clone, .navbar').on('mouseleave', function () {
            $('.mega-menu').removeClass('is-active');
            hideMegaMenu()
        })
    } else {
        $('.site-header .navbar-item').on('click touchstart mouseover', function () {
            var menuLink = $(this).attr('data-navlink-handle');
            $('.navbar-item.is-mega-menu-open').removeClass('is-mega-menu-open');
            $(this).addClass('is-mega-menu-open');
            $('.mega-menu.clone').removeClass('is-active');
            $('.mega-menu[data-parent-link=' + menuLink + ']').css("top", $("#shopify-section-header").height());
            $('.mega-menu[data-parent-link=' + menuLink + ']').css("height", $(window).height() - $("#shopify-section-header").height());
            $('.mega-menu[data-parent-link=' + menuLink + ']').css("overflow-y", "auto");
            $('.mega-menu[data-parent-link=' + menuLink + ']').addClass('is-active');
            showMegaMenu();
        })
        $('.mega-menu.clone, .navbar').on('mouseleave', function () {
            $('.mega-menu.clone').removeClass('is-active');
            hideMegaMenu()
        })
    }

    $('.open-menu').on('click', function () {
        if ($('.mega-menu.mobile').hasClass('active')) {
            $('.mega-menu.mobile').removeClass('active');
            $('.i-hamburger').addClass('is-active');
            $('.i-close').removeClass('is-active');
        } else {
            $('.mega-menu.mobile').css('top', $("#shopify-section-header").height());
            $('.mega-menu.mobile').addClass('active');
            $('.i-close').addClass('is-active');
            $('.i-hamburger').removeClass('is-active');
        }
    });
    let index = 0;
    $('.clone').each(function () {
        var linkAttr = $(this).attr('data-parent-link');
        linkAttr = linkAttr + '-mobile';
        const el = $(this).clone();
        if ($(this).parents('.mega-menu-section__products').length > 0) {
            el.removeClass('clone').attr('data-parent-link', linkAttr).insertAfter('div[data-navlink-handle=' + linkAttr);
            $('div[data-navlink-handle=' + linkAttr).hide();
            el.removeClass('mega-menu').addClass('mega-menu__sub');

            let indexSub = 0;
            el.find('.js-mega-menu-sub-toggle').each(function () {
                const element = el.find('.js-mega-menu-column-mob[data-value="' + $(this).attr('data-value') + '"]');

                if (element != null) {
                    element.insertAfter(this);
                    $(this).on('click', function (e) {
                        e.preventDefault();
                        let isOpen = $(this).hasClass('is-open');
                        $('.js-mega-menu-sub-toggle').each(function () {
                            $(this).removeClass('is-open')
                        })
                        if (isOpen) {
                        } else {
                            $(this).addClass('is-open');
                        }
                        const items = $('.mega-menu__nav-item.is-open');
                        items.each(function () {
                            $(this).removeClass('is-open')
                        })
                        const itemsMega = $('.mega-menu__nav-item+.mega-menu.active');
                        itemsMega.each(function () {
                            $(this).removeClass('active')
                        })
                    })
                    if (indexSub == 0) {
                        $(this).addClass('is-open');
                    }
                    indexSub++;
                    const btn = el.find('.mega-menu__linklist + .mega-menu__btn')?.clone();
                    if (btn.length > 0) {
                        element.append(btn);
                    }
                }

                el.find('.js-mega-menu-column').remove();
            });

        } else {

            el.removeClass('clone').attr('data-parent-link', linkAttr).insertAfter('div[data-navlink-handle=' + linkAttr);
            if (index == 0) {
                el.addClass('active');
            }
        }
        index++;
    });
    $('.clone .js-mega-menu-column-mob').remove();
    $('.navbar-item').each(function () {
        var linkAttr = $(this).attr('data-navlink-handle');
        if ($('div[data-parent-link=' + linkAttr + ']').length > 0) {
            $('a', this).append('<svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<path d="M2 1.5L6 4.5L10 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="square"/>' +
                '</svg>')
            $('a', this).attr('href', '').on('click', function (e) {
                e.preventDefault();
            });
        }
    });

    $('.mega-menu .sr-menu-wrapper.navbar-item').on('click', function () {
        var link = $(this).attr('data-navlink-handle');
        if ($('div[data-parent-link=' + link + ']').hasClass('active')) {
            $('div[data-parent-link=' + link + ']').removeClass('active');
            $(this).removeClass('is-open')
        } else {
            $('.mega-menu.mobile .mega-menu.active').removeClass('active');
            $('div[data-parent-link=' + link + ']').toggleClass('active');
            $(this).addClass('is-open')
        }
        const element = $('.js-mega-menu-sub-toggle');
        element.each(function () {
            $(this).removeClass('is-open')
        })

    });

    document.querySelectorAll('.mega-menu.clone .js-mega-menu-sub-toggle').forEach(item => {
        var element = document.querySelectorAll('.js-mega-menu-column[data-value="' + item.getAttribute('data-value') + '"]');

        function showSubMenu(element, item) {
            document.querySelectorAll('.js-mega-menu-column.is-active').forEach(activeEl => {
                activeEl.classList.remove('is-active')
            });
            document.querySelectorAll('.js-mega-menu-sub-toggle.is-active').forEach(activeEl => {
                activeEl.classList.remove('is-active')
            });
            element.forEach(el => {
                el.classList.add('is-active');
            })
            item.classList.add('is-active');
        }

        item.addEventListener('mouseover', (e) => {
            e.preventDefault();
            showSubMenu(element, item);
        })
        if (element != null) {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                showSubMenu(element, item);
            })
        }
    });

}); 